const SDK_VERSION = '7.66.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
